// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Vo-z","slideIn":"Wo-z"};